import { resolveConverter } from "./converters.js";
import { AttributeValidationError } from "./errors.js";
function toAttributeName(propName) {
  return propName.replace(/[A-Z]/g, (ch) => `-${ch.toLowerCase()}`);
}
function defineObservedAttributes(map) {
  return Object.entries(map).map(([prop, cfg]) => {
    if (cfg.attribute === false) return null;
    return cfg.attribute ?? toAttributeName(prop);
  }).filter((n) => n !== null);
}
function readAttributes(element, map) {
  const result = {};
  for (const [prop, cfg] of Object.entries(map)) {
    if (cfg.attribute === false) {
      result[prop] = cfg.defaultValue;
      continue;
    }
    const attrName = cfg.attribute ?? toAttributeName(prop);
    const converter = cfg.converter ? resolveConverter(cfg.converter) : cfg.type ? resolveConverter(cfg.type) : resolveConverter("string");
    const raw = element.getAttribute(attrName);
    const converted = converter.fromAttribute(raw, attrName);
    const value = converted !== void 0 ? converted : cfg.defaultValue;
    if (value !== void 0 && cfg.validate) {
      const error = cfg.validate(value);
      if (error) {
        throw new AttributeValidationError(attrName, error);
      }
    }
    result[prop] = value;
  }
  return result;
}
function resolveAttributeConfigs(map) {
  return Object.entries(map).map(([prop, cfg]) => {
    const attributeName = cfg.attribute === false ? false : cfg.attribute ?? toAttributeName(prop);
    const converter = cfg.converter ? resolveConverter(cfg.converter) : cfg.type ? resolveConverter(cfg.type) : resolveConverter("string");
    return {
      propertyName: prop,
      attributeName,
      type: cfg.type,
      converter,
      reflect: cfg.reflect ?? false,
      defaultValue: cfg.defaultValue,
      validate: cfg.validate,
      onChange: cfg.onChange,
      hasChanged: cfg.hasChanged
    };
  });
}
export {
  defineObservedAttributes,
  readAttributes,
  resolveAttributeConfigs,
  toAttributeName
};
//# sourceMappingURL=config.js.map
